import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id 03BB26E3-61C3-4FCF-9532-056FC8DC1E4D
 * name toy-brick-minus
 * version: 4.7.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/toy-brick-minus.svg
 * tags
 */
export const ToyBrickMinusIcon = createSvgIcon(<><path d="M23 20H15V18H23V20M13 19C13 15.69 15.69 13 19 13C19.7 13 20.37 13.13 21 13.35V6H19V5C19 3.9 18.11 3 17 3H15C13.9 3 13 3.9 13 5V6H11V5C11 3.9 10.11 3 9 3H7C5.9 3 5 3.9 5 5V6H3V20H13.09C13.04 19.67 13 19.34 13 19Z" /></>, 'ToyBrickMinusIcon');
export default ToyBrickMinusIcon